import dayjs from "dayjs";

import { BeneficiaryType, DateFormat } from "@ctypes";
import { useUser } from "@hooks/user";
import { getCurrentAgeFromDateOfBirth, getUserTaxState } from "@utils";
import { useGoalFlow } from "./useGoalFlow";

/**
 * Shared inputs for the Trump Account Sidecar projections. Both the tax
 * calculation and the recommended contribution routes must resolve the
 * beneficiary date of birth and the state used for the state tax estimate the
 * same way, otherwise the recommendation disagrees with the tax bill shown.
 */
export const useTrumpSidecar = () => {
  const {
    goalProps: {
      beneficiaryId,
      beneficiaryType,
      firstName: firstNameFromGoal,
      dateOfBirth: dateOfBirthFromGoal,
    },
  } = useGoalFlow();

  const { user, beneficiaries } = useUser();

  const beneficiary = beneficiaries?.find((b) => b?.id === beneficiaryId);

  // The add-goal-from-dashboard flow only carries the beneficiary id, so the
  // name and date of birth are resolved from the beneficiary on file. Without
  // this the titles render blank and the projection assumes a newborn.
  const resolvedDateOfBirth = dateOfBirthFromGoal ?? beneficiary?.dateOfBirth ?? undefined;

  const dateOfBirth = resolvedDateOfBirth
    ? dayjs(resolvedDateOfBirth).format(DateFormat.User)
    : undefined;

  const isSelf = beneficiaryType === BeneficiaryType.Self;

  const firstName =
    firstNameFromGoal || beneficiary?.firstName || (isSelf ? user?.firstName : undefined) || "";

  return {
    firstName,
    isSelf,
    dateOfBirth,
    currentAge: getCurrentAgeFromDateOfBirth(dateOfBirth),
    taxState: getUserTaxState(user),
  };
};
